import React from 'react';

function UserTable({ users, onEdit, currentUser }) {
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-left">
        <thead>
          <tr className="bg-slate-50 border-b">
            <th className="p-4 font-semibold text-slate-600">Full Name</th>
            <th className="p-4 font-semibold text-slate-600">Email</th>
            <th className="p-4 font-semibold text-slate-600">Role</th>
            <th className="p-4 font-semibold text-slate-600">Status</th>
            <th className="p-4 font-semibold text-slate-600">Actions</th>
          </tr>
        </thead>
        <tbody>
          {users.map(user => (
            <tr key={user.id} className="border-b hover:bg-slate-50">
              <td className="p-4 font-medium text-slate-800">{user.full_name}</td>
              <td className="p-4 text-slate-600">{user.email}</td>
              <td className="p-4 text-slate-600">{user.role}</td>
              <td className="p-4">
                <span className={`px-2 py-1 text-xs font-semibold rounded-full ${user.is_active ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                  {user.is_active ? 'Active' : 'Inactive'}
                </span>
              </td>
              <td className="p-4">
                {/* Prevent admin from editing their own account in the table to avoid self-lockout */}
                {currentUser.id !== user.id && (
                  <button onClick={() => onEdit(user)} className="bg-slate-200 text-slate-700 hover:bg-slate-300 font-bold py-1 px-3 rounded-lg text-sm">
                    Edit
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default UserTable;